const methodMap = {

    /** 管理登陆接口 **/
    AdminLogin: { url: '/auth/login', method: 'post', apidata: 1 },
    /** 验证黑名单 **/
    blackCheckGet: { url: '/auth/user/vcode', method: 'get', apidata: 1 },
    /**修改密码接口 **/
    userPwdPut: { url: '/auth/user/pwd', method: 'put', },
    /**获取菜单 权限功能点 **/
    authMenuGet: { url: '/auth/menu', method: 'get' },
    /*验证码图片*/
    authVcodeGet: { url: '/auth/vcode', method: 'get', apidata: 1 },
    /*token解析数据*/
    authTokenInfoGet: { url: '/auth/token/info', method: 'get', apidata: 1 },


    // api管理
    /**查询列表* */
    AuthBusapiGet: { url: '/auth/busapi/', method: 'get' },
    /**新增业务api* */
    AuthBusapiPost: { url: '/auth/busapi', method: 'post' },
    /**删除api* */
    AuthBusapiDel: { url: '/auth/busapi/', method: 'delete' },
    /**修改api* */
    AuthBusapiPut: { url: '/auth/busapi/', method: 'put' },
    /**获取优先级 */
    AuthBusapiOrderGet: { url: '/auth/busapi/order/', method: 'get' },
    //所属系统
    AuthTypeGet: { url: '/auth/type/', method: 'get' },

    // 权限菜单
    /**查询列表* */
    AuthFuncGet: { url: '/auth/func/', method: 'get' },
    /**新增业务api* */
    AuthFuncPost: { url: '/auth/func', method: 'post' },
    /**删除api* */
    AuthFuncDel: { url: '/auth/func/', method: 'delete' },
    /**修改api* */
    AuthFuncPut: { url: '/auth/func/', method: 'put' },
    //优先级
    AuthFunOrderGet: { url: '/auth/func/order', method: 'get' },

    // 用户管理
    /**查询列表* */
    AuthUserGet: { url: '/auth/user/', method: 'get' },
    /**查询单条* */
    AuthUserOneGet: { url: '/auth/user/', method: 'get' },
    /**新增* */
    AuthUserPost: { url: '/auth/user/', method: 'post' },
    /**删除* */
    AuthUserDel: { url: '/auth/user/', method: 'delete' },
    /**修改* */
    AuthUserPut: { url: '/auth/user/', method: 'put' },

    /**根据市邮管和市快递协会查询市id和省id* */
    UserProvinceCityId: { url: '/usercenter/apiservice', method: 'post', apidata: 1 },


    // 用户组管理
    /**查询列表* */
    AuthUserGroupGet: { url: '/auth/usergroup/', method: 'get' },
    /**新增业务api* */
    AuthUserGroupPost: { url: '/auth/usergroup', method: 'post' },
    /**删除api* */
    AuthUserGroupDel: { url: '/auth/usergroup/', method: 'delete' },
    /**修改api* */
    AuthUserGroupPut: { url: '/auth/usergroup/', method: 'put' },


    // 角色管理
    /**查询列表* */
    AuthRoleGet: { url: '/auth/role/', method: 'get' },
    /**新增业务api* */
    AuthRolePost: { url: '/auth/role', method: 'post' },
    /**删除api* */
    AuthRoleDel: { url: '/auth/role/', method: 'delete' },
    /**修改api* */
    AuthRolePut: { url: '/auth/role/', method: 'put' },



    // 系统管理
    /**查询列表* */
    AuthSubcGet: { url: '/auth/sub/', method: 'get' },
    /**新增业务api* */
    AuthSubcPost: { url: '/auth/sub', method: 'post' },
    /**删除api* */
    AuthSubcDel: { url: '/auth/sub/', method: 'delete' },
    /**修改api* */
    AuthSubcPut: { url: '/auth/sub/', method: 'put' },



    /**保险公司 */
    // 查询单个
    AuthInsurerGet: { url: '/auth/insurer/', method: 'get' },
    // 查询列表  v2
    AuthInsurerListGet: { url: '/auth/insurer/list', method: 'get' },

    /**新增业务api* */
    AuthInsurerPost: { url: '/auth/insurer', method: 'post' },
    /**删除api* */
    AuthInsurerDel: { url: '/auth/insurer/', method: 'delete' },
    /**修改api* */
    AuthInsurerPut: { url: '/auth/insurer/', method: 'put' },



    /**区域 */
    regionGet: { url: '/region/', method: 'get' },

    /**邮管局-用户 */
    /**查询列表* */
    AuthPostofficeGet: { url: '/auth/postoffice/', method: 'get' },
    /**新增业务api* */
    AuthPostofficePost: { url: '/auth/postoffice', method: 'post' },
    /**删除api* */
    AuthPostofficeDel: { url: '/auth/postoffice/', method: 'delete' },
    /**修改api* */
    AuthPostofficePut: { url: '/auth/postoffice/', method: 'put' },

    /**快递协会-用户 */
    /**查询列表* */
    AuthAssociationGet: { url: '/auth/association/', method: 'get' },
    /**新增业务api* */
    AuthAssociationPost: { url: '/auth/association', method: 'post' },
    /**删除api* */
    AuthAssociationDel: { url: '/auth/association/', method: 'delete' },
    /**修改api* */
    AuthAssociationPut: { url: '/auth/association/', method: 'put' },

    // 换电柜管理
    /*换电柜异常查询*/
    CabinetAdminErrorGet: { url: '/cabinet/admin/error', method: 'get' },
    /**换电柜记录 */
    CabinetAdminRecordGet: { url: 'cabinet/admin/record', method: 'get' },

    //换电柜管理
    //换电柜管理界面（查询接口）
    cabinetManage: { url: '/cabinet/v2/findChargingManage', method: 'post' },
    //绑定、编辑网点
    cabinetEditCharging: { url: '/cabinet/v2/editCharging', method: 'post' },
    //解除网点
    cabinetDelCharging: { url: '/cabinet/v2/delCharging', method: 'post' },
    //仓门管理查询
    cabinetRoomManage: { url: '/cabinet/v2/findRoomManage', method: 'post' },
    //请求开门、开始充电、停止充电指令
    cabinetPubOperation: { url: '/cabinet/v2/pubOperation', method: 'post' },
    //新增换电柜操作日志
    cabinetAddOperationLog: { url: '/cabinet/v2/addOperationLog', method: 'post' },
    //新增换电柜操作日志
    cabinetResetLock: { url: '/cabinet/v2/resetLock', method: 'post' },

    //电池管理
    //电池管理查询（查询接口）
    cabinetBattery: { url: '/cabinet/v2/findBatteryManage', method: 'post' },

    // 异常信息管理
    //异常信息管理（查询接口）
    cabinetAbnormal: { url: '/cabinet/v2/findAbnormal', method: 'post' },
    //异常信息处理
    cabinetApiservice: { url: '/cabinet/v2/handleAbnormal', method: 'post' },

    //换电柜操作日志（查询接口）
    cabinetControllerLog: { url: '/cabinet/v2/findOperationLog', method: 'post' },

    //换电记录（查询接口）
    cabinetReacord: { url: '/cabinet/v2/findChargingRecord', method: 'post' },

    // 推送管理
    // 查询推送管理界面
    cabinetV2FindPushList: { url: '/cabinet/v2/FindPushList', method: 'post' },
    // 新增推送
    cabinetV2AddPush: { url: '/cabinet/v2/AddPush', method: 'post' },
    // 查询内部所有用户
    cabinetV2InternalUser: { url: '/cabinet/v2/InternalUser', method: 'post' },
    // 编辑推送
    cabinetV2EditPush: { url: '/cabinet/v2/EditPush', method: 'post' },
    // 查询推送记录
    cabinetV2FindPushRecording: { url: '/cabinet/v2/FindPushRecording', method: 'post' },
    // 查询推送详情
    cabinetV2PushInfo: { url: '/cabinet/v2/PushInfo', method: 'post' },


    /*区域*/
    /**查询列表* */
    DispatchRegionGet: { url: '/dispatch/region', method: 'get' },


    /** 用户登陆解锁 **/
    AdminUnlock: { url: '/user/unlock', method: 'post' },
    /** 后台用户列表 **/
    UserList: { url: '/user/list', method: 'get' },
    /** 获取树状列表 **/
    treeurl: { url: '/user/tree', method: 'post' },
    /** 获取验证码图片 **/
    identifyImg: { url: '/identifyImg', method: 'post' },
    /**用户信息 */
    UserInfo: { url: '/user/info', method: 'get' },
    /** 添加后台用户 **/
    AdminAddUser: { url: '/user/add', method: 'post' },
    /** 编辑后台用户 **/
    AdminEditUser: { url: '/user/edit', method: 'post' },
    /** 重置后台用户密码 **/
    RestPassword: { url: '/user/rest_password', method: 'post' },


    // 获取二维码列表
    codeInfo: { url: '/qrcode/index', method: 'get' },
    // 创建二维码
    create_code: { url: '/qrcode/index', method: 'post' },
    // 二维码发放数量
    code_grant_num: { url: 'qrcode/count', method: 'get' },
    // 导出二维码
    export_code: { url: '/qrcode/ExportZip', method: 'get' },


    // 车辆管理
    // 获取车辆列表
    vehicleList: { url: '/vehicle/index', method: 'get' },
    // 修改车辆信息
    editvehicle: { url: '/vehicle/index', method: 'put' },
    // 快递公司后台锁车
    expressLockVehicle: { url: '/vehicle/express/lock', method: 'post' },
    // 快递公司后台解锁
    expressUnlockVehicle: { url: '/vehicle/express/unLock', method: 'post' },
    // 获取车辆详情
    vehicleDetail: { url: '/vehicle/detail', method: 'get' },
    // 车辆详情，查询车辆日志
    vehicleDetailLog: { url: '/biz/apiservice', method: 'post', apidata: 1 },
    // 获取车辆二维码
    vehicleCodeImg: { url: '/qrcode/image', method: 'get' },
    // 图表信息
    vehicleChart: { url: '/vehicle/chart', method: 'get' },
    // 获取车辆gps，画行驶轨迹
    vehicleGPS: { url: '/traffic/gpsdelreppoint', method: 'post' },
    // 车辆地图
    vehicleMap: { url: '/vehicle/map', method: 'get' },
    // 查询老系统车辆信息
    vehicleOld: { url: '/vehicle/old', method: 'get' },
    // 车辆转入新系统
    vehicleMigrate: { url: '/vehicle/migrate', method: 'post' },
    // 车辆导出
    // vehicleStoreExport: { url: '/vehicle/store/export', method: 'get' },
    vehicleStoreExport: { url: '/rent/Vehicle/Export', method: 'get' },
    // 获取骑手身份证
    vehicleDriver: { url: '/vehicle/driver', method: 'get' },
    // 获取本月与上个月有轨迹数据的日期
    vehicleDatevalues: { url: '/vehicle/datevalues', method: 'post' },
    // 租赁后台锁车
    vehicleRentLock: { url: '/vehicle/rent/lock', method: 'post' },
    // 租赁后台解锁
    vehicleRentUnLock: { url: '/vehicle/rent/unLock', method: 'post' },
    // 租赁编辑车辆
    // vehicleRent: { url: '/vehicle/rent/', method: 'put' },
    vehicleRent: { url: '/rent/Vehicle/', method: 'put' },
    // 车辆以及电池列表
    productServerApiservice: { url: 'product-server/apiservice', method: 'post', apidata: 1 },

    // 发牌流程
    // 商品管理
    // 获取商品列表
    goodsList: { url: '/postoffice/goods', method: 'get' },
    // 获取商品详情
    goodsDetail: { url: '/postoffice/goods/', method: 'get' },
    // 获取目录
    categoryList: { url: '/postoffice/catalogue', method: 'post' },
    // 获取品牌
    categoryBrand: { url: '/postoffice/goodsbrand', method: 'get' },
    // 行驶证打印
    licensePrint: { url: '/postoffice/license', method: 'get' },
    // 车牌号导入
    platenumLeadin: { url: '/multicodetask/task/platenum', method: 'post' },
    // 修改行驶证状态
    editLicense: { url: '/postoffice/license/', method: 'put' },

    // 发牌流程
    // 保单管理
    // 获取保单列表
    policyList: { url: '/postoffice/warranty', method: 'get' },
    // 新增保单
    addpolicy: { url: '/postoffice/warranty', method: 'post' },
    // 修改保单信息
    editpolicy: { url: '/postoffice/warranty/', method: 'put' },
    // 删除保单
    deletepolicy: { url: '/postoffice/warranty/', method: 'delete' },
    // 批量删除保单
    policyBatchDelete: { url: '/postoffice/Warranty/BatchDel', method: 'post' },
    // 上传附件
    policySecureFile: { url: '/postoffice/Warranty/SecureFile', method: 'post' },
    // 获取待保车辆
    securevehicle: { url: '/postoffice/securevehicle', method: 'get' },
    // 获取快递公司列表
    getExpressList: { url: '/postoffice/express/select', method: 'get' },
    // 保单导入
    policyLeadin: { url: '/postoffice/warranty/leadin', method: 'post' },
    // 保单导出
    policyExport: { url: '/postoffice/insurance/export/vehicle', method: 'get' },

    // 电子围栏
    /** 查询列表 **/
    vehicleRailGet: { url: '/vehicle/rail', method: 'get' },
    /** 新增 **/
    vehicleRailPost: { url: '/vehicle/rail/', method: 'post' },
    /** 编辑 **/
    vehicleRailPut: { url: '/vehicle/rail/', method: 'put' },
    /** 删除 **/
    vehicleRailDel: { url: '/vehicle/rail', method: 'delete' },


    /**违章车辆查询 */
    /** 查询列表 **/
    vehicleRaillistGet: { url: '/vehicle/raillist', method: 'get' },
    /** 新增 **/
    vehicleRaillistPost: { url: '/vehicle/raillist/', method: 'post' },
    /** 编辑 **/
    vehicleRaillistPut: { url: '/vehicle/raillist/', method: 'put' },
    /** 删除 **/
    vehicleRaillistDel: { url: '/vehicle/raillist', method: 'delete' },



    // 供应商管理
    // 查询详情  v2
    getSupplier: { url: '/auth/supplier', method: 'get' },
    // 查询列表
    getSupplierList: { url: '/auth/supplier/list', method: 'get' },
    // 新增
    addSupplier: { url: '/auth/supplier', method: 'post' },
    // 修改
    editSupplier: { url: '/auth/supplier/', method: 'put' },
    // 删除
    deleteSupplier: { url: '/auth/supplier/', method: 'delete' },
    // 重置密码
    resetPwd: { url: 'auth/user/', method: 'put' },

    // 门店管理
    // 查询列表
    getStore: { url: '/auth/store', method: 'get' },
    getStoreList: { url: 'usercenter/apiservice', method: 'post', apidata: 1 },
    // 新增
    addStore: { url: '/auth/store', method: 'post' },
    // 修改
    editStore: { url: '/auth/store/', method: 'put' },
    // 删除
    deleteStore: { url: '/dispatch/stores/', method: 'delete' },

    // 充电柜业务
    // 获取网点绑定重置数据
    getBangdResetList: { url: '/cabinet/admin/board', method: 'get' },
    // 重置网点/绑定门店
    setReset: { url: '/cabinet/admin/store/', method: 'post' },
    //门店列表模糊查询
    dispatchStores: { url: '/dispatch/stores/', method: 'get' },

    deleteStore: { url: '/auth/store/', method: 'delete' },

    cabinetAdminEmpty: { url: '/cabinet/admin/empty', method: 'post' },

    // 快递公司管理
    // 查询详情 v2
    getExpress: { url: '/auth/express', method: 'get' },
    // // 查询详情 v2
    // getExpress: { url: '/postoffice/express/select', method: 'get' },
    // 查询列表
    getExpressManageList: { url: '/auth/express/list', method: 'get' },
    // 新增
    addExpress: { url: '/auth/express', method: 'post' },
    // 修改
    editExpress: { url: '/auth/express/', method: 'put' },
    // 删除
    deleteExpress: { url: '/auth/express/', method: 'delete' },

    // 租赁模块
    // 基础项目管理
    // 获取服务项目列表
    // getServiceitem: { url: '/rent/serviceitem', method: 'get' },
    getServiceitem: { url: '/order/apiservice', method: 'post', apidata: 1 },
    // 新增服务项目管理
    // addServiceitem: { url: '/rent/serviceitem', method: 'post' },
    addServiceitem: { url: '/order/apiservice', method: 'post', apidata: 1 },
    // 删除服务项目
    // delServiceitem: { url: '/rent/serviceitem', method: 'delete' },
    delServiceitem: { url: '/order/apiservice', method: 'post', apidata: 1 },
    // 编辑服务项目
    // editServiceitem: { url: '/rent/serviceitem', method: 'put' },
    editServiceitem: { url: '/order/apiservice', method: 'post', apidata: 1 },
    // 批量修改启用禁用项目状态
    // updServiceitem: { url: '/rent/serviceitem/upstatus', method: 'post' },
    updServiceitem: { url: '/order/apiservice', method: 'post', apidata: 1 },
    // 获取区域树
    getAreaTree: { url: '/rent/regiontree', method: 'get' },
    // 新增套餐列模糊查询
    getGoods: { url: '/postoffice/goods', method: 'get' },
    // 规格列表获取
    getskus: { url: '/postoffice/goods', method: 'get' },
    // 获取套餐列表
    getsetMeal: { url: '/rent/package', method: 'get' },
    // 新增服务套餐
    addSetMeal: { url: '/rent/package', method: 'post' },
    // 修改服务套餐
    editSetMeal: { url: '/rent/package', method: 'put' },
    //批量更新套餐状态
    updsetMealStatus: { url: '/rent/package/upstatus', method: 'post' },
    //使用区域模糊查询
    getregion: { url: '/region', method: 'get' },
    //退款单列表
    getReturnList: { url: '/rent/returnbill', method: 'get' },
    //退款单审核按钮（通过/拒绝）
    subReturnList: { url: '/rent/returnbill', method: 'put' },
    //发起退款按钮
    sendRentRefund: { url: '/rent/refund', method: 'post' },
    //押金单列表
    getDepositList: { url: '/rent/depositbill', method: 'get' },
    //租赁联保订单
    getwarrantybillList: { url: '/rent/warrantybill', method: 'get' },

    // 租赁维修订单
    // 查询列表
    repairorderGet: { url: '/rent/repairorder', method: 'get' },
    // 查询详情
    repairDetailGetxx: { url: '/warranty/repair/detail', method: 'get' },
    //支付单列表
    getpayList: { url: '/rent/paybill', method: 'get' },
    //流水单列表
    getFlowList: { url: '/rent/flowbill', method: 'get' },
    // 租赁获取联保订单列表
    getRentWarrantybill: { url: '/rent/warrantybill', method: 'get' },
    // 维修订单查询列表
    rentRepairorderGet: { url: '/rent/repairorder', method: 'get' },
    //流水导出
    postFlowOut: { url: '/order/apiservice', method: 'post', apidata: 1 },
    //服务单列表
    getServiceList: { url: '/rent/serviceorder', method: 'get' },
    //租赁单列表
    getrentorderList: { url: '/rent/rentorder', method: 'get' },
    // getrentorderList: { url: '/search/apiservice', method: 'get' },
    // 通过门店名称模糊查询
    getSearchStore: { url: '/cabinet/admin/search/store', method: 'get' },
    // 通过骑手名称模糊查询
    getSearchDriver: { url: '/dispatch-server/apiservice', method: 'get', apidata: 1 },
    // 车辆管理通过骑手名称模糊查询
    getDriverList: { url: '/dispatch/driver', method: 'get' },
    // 通过换电区域模糊查询
    getSearchCity: { url: '/cabinet/admin/search/area', method: 'get' },
    // 删除套餐
    delSetMeal: { url: '/rent/package', method: 'delete' },
    // 解除套餐
    relieveSetMeal: { url: '/rent/service/closure', method: 'post' },
    // 车辆管理（门店）
    getvehicleList: { url: '/vehicle/storevehiclelist', method: 'get' },
    // 获取单个车辆里程报表
    getMileage: { url: '/vehicle/mileage', method: 'get' },
    // 获取租赁业务区域
    // getRentArea: { url: '/rent/area', method: 'get' },
    getRentArea: { url: '/biz/apiservice', method: 'post', apidata: 1 },
    // 提交租赁业务区域
    // subRentArea: { url: '/rent/area', method: 'post' },
    subRentArea: { url: '/biz/apiservice', method: 'post', apidata: 1 },

    // 租赁车辆管理新接口
    // 车辆列表
    // getNewVehicleList: { url: '/rent/Vehicle', method: 'get' },
    getNewVehicleList: { url: '/vehicle/apiservice', method: 'post', apidata: 1 },
    // 租赁车辆详情
    getVehicleDetail: { url: '/rent/Vehicle/', method: 'get' },


    // 联保
    // 基础资料 /postoffice/products/
    // 查询列表
    warrantyProductsGet: { url: '/warranty/products', method: 'get' },
    // 查询单个
    warrantyProductsSkusGet: { url: '/warranty/products/skus/', method: 'get' },
    // 商品资料导出
    warrantyProductsLeadoutGet: { url: '/warranty/products/leadout', method: 'post' },

    // 客户资料
    // 客户列表
    getCustomerList: { url: '/warranty/customers/info', method: 'get' },
    // 新增客户资料
    addCustomerList: { url: '/warranty/customers/info', method: 'post' },
    // 编辑客户资料
    editCustomerList: { url: '/warranty/customers/info', method: 'put' },
    // 删除客户资料
    deleteCustomerList: { url: '/warranty/customers/info', method: 'delete' },
    // 获取秘钥
    getCustomerSecret: { url: '/warranty/customers/', method: 'get' },
    // 获取秘钥
    editCustomerSecret: { url: '/warranty/customers/', method: 'put' },
    // 联保方案
    // 获取联保方案列表
    getGuaranteeSchema: { url: '/warranty/warrantyschemes', method: 'get' },
    // 获取联保方案详情
    getGuaranteeSchemaTree: { url: '/warranty/warrantyschemes/', method: 'get' },
    // 新增联保方案详情
    addGuaranteeSchema: { url: '/warranty/warrantyschemes', method: 'post' },
    // 编辑联保方案详情
    editGuaranteeSchema: { url: '/warranty/warrantyschemes/', method: 'put' },
    // 联保方案修改状态
    guaranteeSchemaStatus: { url: '/warranty/warrantyschemes/status', method: 'put' },
    // 删除联保方案
    deleteGuaranteeSchema: { url: '/warranty/warrantyschemes/', method: 'delete' },



    // 车辆架构
    // 查询列表
    warrantyVehicleelementsGet: { url: '/warranty/elements', method: 'get' },
    // 新增
    warrantyVehicleelementsPost: { url: '/warranty/elements/', method: 'post' },
    // 修改
    warrantyVehicleelementsPut: { url: '/warranty/elements/', method: 'put' },
    // 删除
    warrantyVehicleelementsDel: { url: '/warranty/elements/', method: 'delete' },
    // 获取车辆部件所属区域
    warrantyVehicleaeraGet: { url: '/warranty/vehicleareas', method: 'get' },
    // 获取车辆部件优先级
    warrantyElementOrderGet: { url: '/warranty/elements/order', method: 'get' },
    //导出
    warrantyElementLeadout: { url: '/warranty/elements/leadout', method: 'post' },



    // 配件价格
    // 查询列表
    warrantyProductsFittingpricesGet: { url: '/warranty/prices', method: 'get' },
    // 修改
    warrantyProductsFittingpricesPut: { url: '/warranty/prices/', method: 'put' },
    // 删除
    warrantyProductsFittingpricesDel: { url: '/warranty/prices/', method: 'delete' },
    // 导出
    warrantyPricesLeadoutGet: { url: '/warranty/prices/leadout', method: 'post' },
    // 导入
    warrantyPricesLeadinGet: { url: '/warranty/prices/leadin', method: 'post' },



    // 维修订单
    // 查询列表
    warrantyRepairGet: { url: '/warranty/repair', method: 'get' },
    // 修改
    //warrantyProductsFittingpricesPut: { url: '/warranty/repair/', method: 'put' },
    // 删除
    //warrantyProductsFittingpricesDel: { url: '/warranty/repair/', method: 'delete' },


    // 车辆BOM列表
    getVehicleBOM: { url: '/warranty/vehicleboms', method: 'get' },
    // 车辆BOM导出
    VehicleBOMLeadout: { url: '/warranty/vehicleboms/leadout', method: 'post' },
    // 车辆BOM导入
    VehicleBOMLeadin: { url: '/warranty/vehicleboms/leadin', method: 'post' },
    // 获取车辆类型
    getVehicleType: { url: '/warranty/vehicletypes', method: 'get' },
    // 根据车辆类型，获取基础BOM树
    getTreeBOM: { url: 'warranty/elements/tree', method: 'get' },
    // 新增车辆BOM信息
    addVehicleBOM: { url: '/warranty/vehicleboms', method: 'post' },
    // 根据ID获取车辆BOM信息
    getVehicleDetailBOM: { url: '/warranty/vehicleboms/', method: 'get' },
    // 根据ID更新车辆BOM信息
    editVehicleDetailBOM: { url: '/warranty/vehicleboms/', method: 'put' },
    // 根据ID删除车辆BOM信息
    deleteVehicleDetailBOM: { url: '/warranty/vehicleboms/', method: 'delete' },
    // 获取客户列表
    getCustomer: { url: '/warranty/customers', method: 'get' },
    // 获取商品目录列表
    getBOMGoodsCatalogue: { url: '/warranty/products/catalogue', method: 'get' },
    // 获取具体商品
    getBOMGoodsSKU: { url: '/warranty/products/skus/catalogue', method: 'get' },
    // 获取树列表具体商品，商品模糊查询
    getTreeGoodsSKU: { url: '/warranty/products/searching', method: 'get' },

    // 市场运营
    // 维修价格方案
    getSchemes: { url: '/warranty/schemes', method: 'get' },
    // 方案导出
    schemasLeadout: { url: '/warranty/schemes/leadout', method: 'post' },
    // 方案导入
    schemasLeadin: { url: '/warranty/schemes/leadin', method: 'post' },
    // 根据车辆id，获取车辆BOM树
    getVehicleTreeBOM: { url: '/warranty/vehicleboms/sku', method: 'get' },
    // 获取价格方案详情BOM树
    getVehiclePriceBOM: { url: '/warranty/schemes/', method: 'get' },
    // 更新价格方案详情BOM树
    editVehiclePriceBOM: { url: '/warranty/schemes/', method: 'put' },
    // 新增价格方案
    addVehiclePriceBOM: { url: '/warranty/schemes', method: 'post' },
    // 删除价格方案
    deleteVehiclePriceBOM: { url: '/warranty/schemes/', method: 'delete' },
    // 获取区域树
    getAreaTreeAll: { url: '/warranty/schemes/region', method: 'get' },
    // 获取所有区域树
    getAreaTreeAllList: { url: '/warranty/region', method: 'get' },

    // 业务单据
    // 联保订单
    // 获取联保订单列表
    getGuaranteeOrder: { url: '/warranty/orders', method: 'get' },
    // 获取联保订单详情
    getOrderDetailTree: { url: '/warranty/orders/', method: 'get' },
    // 新增联保订单详情
    addGuaranteeOrder: { url: '/warranty/orders', method: 'post' },
    // 新增联保订单详情
    editGuaranteeOrder: { url: '/warranty/orders/', method: 'put' },
    // 联保订单修改状态
    guaranteeOrderStatus: { url: '/warranty/orders/status', method: 'put' },

    // 骑手管理
    // 获取骑手列表
    riderList: { url: '/dispatch/driver', method: 'get' },
    // 查看详情
    riderDetail: { url: '/dispatch/driver', method: 'get' },
    // 获取骑手详情
    addrider: { url: '/dispatch/driver', method: 'post' },
    //解除门店绑定
    // untievehicle: { url: '/dispatch/store/unvehicle', method: 'post' },
    untievehicle: { url: '/rent/Vehicle/UnBindStore', method: 'post' },
    // 修改骑手信息
    editrider: { url: '/dispatch/driver/', method: 'put' },
    // 获取骑手身份证
    getIdNumber: { url: '/dispatch/driver/identify', method: 'get' },
    // 删除骑手
    deleterider: { url: '/dispatch/driver/', method: 'delete' },
    // 获取站点
    getSite: { url: 'dispatch/site', method: 'get' },
    // 导入骑手
    riderLeadin: { url: '/dispatch-server/apiservice', method: 'post', apidata: 1 },

    // 消息推送管理
    // 获取消息模板列表
    getMessage: { url: '/template/message', method: 'get' },
    // 新增消息模板列表
    addMessage: { url: '/template/message', method: 'post' },
    // 编辑消息模板列表
    editMessage: { url: '/template/message', method: 'put' },
    // 删除消息模板列表
    delMessage: { url: '/template/message', method: 'delete' },
    // 获取app参数列表
    getApp: { url: '/template/umeng', method: 'get' },
    // 新增app参数列表
    addApp: { url: '/template/umeng', method: 'post' },
    // 编辑app参数列表
    editApp: { url: '/template/umeng', method: 'put' },
    // 删除app参数列表
    delApp: { url: '/template/umeng', method: 'delete' },
    // app管理
    // 获取app列表，不带分页
    getAppCodeList: { url: '/template/dwapp', method: 'get' },
    // 获取app列表，带分页
    getAppList: { url: '/template/dwapp/page', method: 'get' },
    // 新增app列表
    addAppList: { url: '/template/dwapp', method: 'post' },
    // 删除app列表
    deleteAppList: { url: '/template/dwapp/', method: 'delete' },
    // 编辑app列表
    editAppList: { url: '/template/dwapp/', method: 'put' },
    // 设置通知树，获取数组
    getNoticeTree: { url: '/template/dwapp/', method: 'get' },
    // 设置通知树
    setNoticeTree: { url: '/template/dwapp/', method: 'put' },
    // 修改APP列表状态
    changeAppListStatus: { url: '/template/dwapp/', method: 'put' },
    // 通知事件管理
    // 获取通知事件列表，带分页
    getNotice: { url: '/template/event/page', method: 'get' },
    // 获取通知事件列表，不带分页
    getNoticeList: { url: '/template/event', method: 'get' },
    // 获取通知事件详情
    getNoticeDetail: { url: '/template/event/', method: 'get' },
    // 新增通知事件
    addNoticeDetail: { url: '/template/event', method: 'post' },
    // 修改通知事件
    editNoticeDetail: { url: '/template/event/', method: 'put' },
    // 删除通知事件
    deleteNoticeDetail: { url: '/template/event/', method: 'delete' },
    // 获取优先级列表
    NoticeOrder: { url: '/template/event/order', method: 'get' },
    // 获取app列表
    getAppType: { url: '/template/dwapp/type', method: 'get' },
    // 修改通知状态
    changeNoticeStatus: { url: '/template/event/', method: 'put' },
    // 获取关联模板列表
    getTemplateLink: { url: '/template/message/list', method: 'get' },

    //网点绑定重置获取柜子信息
    getCabinet: { url: '/cabinet/admin/room', method: 'get' },
    //解除网点绑定
    delStore: { url: '/cabinet/admin/store', method: 'delete' },
    //换电柜子指令操作
    postCabinetRoom: { url: '/cabinet/admin/room', method: 'post' },

    // 日志服务
    // 业务日志
    businessLogGet: { url: '/log/business', method: 'get' },
    // 平台日志
    platformLogGet: { url: '/log/platform', method: 'get' },
    // 系统日志
    systemLogGet: { url: '/log/system', method: 'get' },
    // 信号灯日志
    trafficLightGet: { url: '/traffic/light', method: 'get' },

    //锁车管理
    // 获取锁车列表
    getVehicleLock: { url: '/vehicle/lock', method: 'get' },
    // 锁车/批量锁车
    putVehicleLock: { url: '/vehicle/lock', method: 'put' },
    // 锁车/批量锁车
    putVehicleBatchLock: { url: 'vehicle/batch/lock', method: 'put' },

    // 供应商子账号
    /**查询列表* */
    AuthSubuserGet: { url: '/auth/subuser/', method: 'get' },
    /**查询单条* */
    AuthSubuserOneGet: { url: '/auth/subuser/', method: 'get' },
    /**新增* */
    AuthSubuserPost: { url: '/auth/subuser/', method: 'post' },
    /**删除* */
    AuthSubuserDel: { url: '/auth/subuser/', method: 'delete' },
    /**修改* */
    AuthSubuserPut: { url: '/auth/subuser/', method: 'put' },

    // 多码合一
    // 获取任务列表
    getTask: { url: '/multicodetask/task', method: 'get' },
    // 新增任务
    addTask: { url: '/multicodetask/task', method: 'post' },
    // 删除任务
    deleteTask: { url: '/multicodetask/task/', method: 'delete' },
    // 修改任务
    editTask: { url: '/multicodetask/task/', method: 'put' },
    // 修改任务状态
    editTaskStatus: { url: '/multicodetask/task/status', method: 'put' },
    // 获取任务详情
    getTaskDetail: { url: '/multicodetask/task/', method: 'get' },
    // 获取模糊搜索的商品
    getTaskGoods: { url: '/product-server/apiservice', method: 'post', apidata: 1 },
    // 获取操作员列表
    getOperator: { url: '/multicodetask/task/user', method: 'get' },
    // 获取三级目录
    getTaskGoodsCatalogue: { url: '/multicodetask/products/catalogue', method: 'get' },
    // 获取四级sku
    getTaskGoodsSKU: { url: '/multicodetask/products/skus/catalogue', method: 'get' },

    // 设备管理
    /**查询列表* */
    chargeDeviceGet: { url: '/charge/device', method: 'get' },
    /**新增* */
    chargeDevicePost: { url: '/charge/device', method: 'post' },
    /**删除* */
    chargeDeviceDel: { url: '/charge/device', method: 'delete' },
    /**修改* */
    chargeDevicePut: { url: '/charge/device', method: 'put' },
    // 获取站点
    chargeSearchSiteGet: { url: 'charge/search/site', method: 'get' },
    // 获取详情列表
    chargeDeviceDetail: { url: '/charge/device/detail', method: 'get' },


    // 设备管理
    /**查询列表* */
    chargeLogGet: { url: '/charge/log', method: 'get' },



    // 设备管理
    /**异常数据* */
    chargeChartFaultGet: { url: '/charge/chart/fault', method: 'get' },
    //饼图数据
    chargeChartPieGet: { url: '/charge/chart/pie', method: 'get' },
    //柱状图数据   /charge/chart/area
    chargeChartBarGet: { url: '/charge/chart/bar', method: 'get' },
    //地图数据   /charge/chart/map
    chargeChartMapGet: { url: '/charge/chart/map', method: 'get' },
    //实时详情数据   /charge/chart/current
    chargeChartCurrentGet: { url: '/charge/chart/current', method: 'get' },
    //今日充电数据   /charge/chart/total
    chargeChartTotalGet: { url: '/charge/chart/total', method: 'get' },


    // 禁停区管理
    // 禁停区列表
    trafficNoparking: { url: '/traffic/noparking', method: 'get' },
    // 作废禁停区
    delTrafficNoparking: { url: '/traffic/noparking', method: 'delete' },
    // 查看禁停区详情
    trafficNoparkingDetail: { url: '/traffic/noparking/detail', method: 'get' },
    // 启用禁用禁停区
    trafficNoparkingStatus: { url: '/traffic/noparking/status', method: 'put' },
    // 新增禁停区
    addTrafficNoparking: { url: '/traffic/noparking', method: 'post' },
    // 新增禁停区
    editTrafficNoparking: { url: '/traffic/noparking', method: 'put' },
    // 新增禁停区中停车区域
    addTrafficNoparkingDetail: { url: '/traffic/noparking/detail', method: 'post' },
    //指定行政区域内所有未作废的禁停区
    trafficNoparkingArea: { url: '/traffic/noparking/area', method: 'get' },

    //禁行区管理
    //禁行区列表
    trafficNoentry: { url: '/traffic/noentry', method: 'get' },
    //新增禁行区
    postTrafficNoentry: { url: '/traffic/noentry', method: 'post' },
    //编辑禁行区
    putTrafficNoentry: { url: '/traffic/noentry', method: 'put' },
    //查看禁行区详情
    trafficNoentryDetail: { url: '/traffic/noentry/detail', method: 'get' },
    //删除禁行区
    delTrafficNoentry: { url: '/traffic/noentry', method: 'delete' },
    //启用禁用禁行区
    trafficNoentryStatus: { url: '/traffic/noentry/status', method: 'put' },
    //根据交警的用户查询对应的区域信息
    trafficNoentryUserarea: { url: '/traffic/noentry/userarea', method: 'get' },
    //根据交警的用户查询对应的区域信息
    trafficNoentryArea: { url: '/traffic/noentry/area', method: 'get' },


    //道路管理
    //道路列表
    trafficRoad: { url: '/traffic/Road', method: 'get' },
    //新增道路
    roadAdd: { url: '/traffic/Road', method: 'post' },
    //删除道路
    roadDel: { url: '/traffic/Road', method: 'delete' },
    //道路启用禁用
    roadPut: { url: '/traffic/Road', method: 'put' },
    //路段列表
    trafficRoadSection: { url: '/traffic/RoadSection', method: 'get' },
    //新增路段
    addTrafficRoadSection: { url: '/traffic/RoadSection', method: 'post' },
    //编辑路段
    putTrafficRoadSection: { url: '/traffic/RoadSection', method: 'put' },
    //删除路段
    deleteTrafficRoadSection: { url: '/traffic/RoadSection', method: 'delete' },
    //路段设置上下行标记
    trafficRoadSectionMark: { url: '/traffic/RoadSection/Mark', method: 'put' },

    /**
     * 交通灯管理
     */
    // 获取交通灯列表
    trafficLightList: { url: '/biz/apiservice', method: 'post', apidata: 1 },
    // 新增交通灯
    trafficLightAdd: { url: '/biz/apiservice', method: 'post', apidata: 1 },
    // 编辑交通灯（编辑及禁用启用）
    trafficLightEdit: { url: '/biz/apiservice', method: 'post', apidata: 1 },
    // 删除交通灯
    trafficLightDelete: { url: '/biz/apiservice', method: 'post', apidata: 1 },
    // 编辑交通灯信息
    trafficLightConfig: { url: '/biz/apiservice', method: 'post', apidata: 1 },

    //违章车辆查询
    //违章车辆列表
    trafficPeccancy: { url: '/traffic/Peccancy', method: 'get' },
    // 违章处理规则列表
    trafficPeccancyRule: { url: '/traffic/peccancy/rule', method: 'get' },
    // 违章类型列表
    trafficSelectPeccancyType: { url: '/traffic/select/peccancyType', method: 'get' },
    // 新增违章处理规则
    addTrafficPeccancyRule: { url: '/traffic/peccancy/rule', method: 'post' },
    // 更新违章处理规则
    editTrafficPeccancyRule: { url: '/traffic/peccancy/rule', method: 'put' },
    // 获取违章锁车和短信发送按钮状态
    trafficPpeccancyParam: { url: '/traffic/peccancyParam', method: 'get' },
    // 新增或更新违章按钮参数
    editTrafficPpeccancyParam: { url: '/traffic/peccancyParam', method: 'put' },
    // 处理违章
    putTrafficPeccancy: { url: '/traffic/Peccancy/', method: 'put' },
    // 违章车辆轨迹回放新接口
    // vehicleApiservice: { url: 'vehicle/apiservice', method: 'post', apidata: 1 },

    // 交警队
    /**查询列表* */
    authTrafficpoliceGet: { url: '/auth/trafficpolice', method: 'get' },
    /**新增* */
    authTrafficpolicePost: { url: '/auth/trafficpolice', method: 'post' },
    /**删除* */
    authTrafficpoliceDel: { url: '/auth/trafficpolice', method: 'delete' },
    /**修改* */
    authTrafficpolicePut: { url: '/auth/trafficpolice', method: 'put' },

    // 交警人员维护
    /**查询列表* */
    authPoliceManGet: { url: '/auth/police-man', method: 'get' },
    /**新增* */
    authPoliceManPost: { url: '/auth/police-man', method: 'post' },
    /**删除* */
    authPoliceManDel: { url: '/auth/police-man', method: 'delete' },
    /**修改* */
    authPoliceManPut: { url: '/auth/police-man', method: 'put' },
    /**获取角色 */
    authRoleListGet: { url: '/auth/role-list', method: 'get' },
    /**获取当前区域 */
    authTrafficpoliceSelfGet: { url: 'auth/trafficpolice/self', method: 'get' },

    // 骑手驾照
    /**查询列表* */
    examLicenceGet: { url: '/exam/licence', method: 'get' },
    // 处理违章
    examLicencePut: { url: '/exam/licence/', method: 'put' },
    // 修改打印状态
    examDriverlicencePut: { url: '/exam/driverlicence/', method: 'put' },
    // 照片退回
    dispatchServerApiservicePost: { url: '/dispatch-server/apiservice', method: 'post', apidata: 1 },
    //照片退回按钮
    expressprintdriverslicensestatusGet: { url: '/biz/expressprintdriverslicensestatus', method: 'get' },


    // 历史成绩
    /**查询列表* */
    examHistoryGet: { url: '/exam/history', method: 'get' },

    // 报名信息
    /**考试场列表* */
    examGet: { url: '/exam', method: 'get' },
    /**考试批次列表* */
    examBatchGet: { url: '/exam/batch', method: 'get' },
    /**新增员工* */
    examPost: { url: '/exam', method: 'post' },
    /**删除* */
    // authTrafficpoliceDel: { url: '/auth/trafficpolice', method: 'delete' },
    /**修改* */
    // authTrafficpolicePut: { url: '/auth/trafficpolice', method: 'put' },

    // 处理违章
    // handlePeccancy: { url: '/traffic/Peccancy/Process/', method: 'put' },
    // 获取轨迹回放点
    peccancyLocus: { url: '/traffic/Peccancy/Locus/', method: 'get' },
    // 获得违规的骑手列表
    peccancyDriver: { url: '/dispatch/select/driver', method: 'post' },

    // 配额管理
    // 获取配额申请列表
    getquota: { url: '/postoffice/license/quota', method: 'get' },
    // 新增申请
    addquota: { url: '/postoffice/license/quota', method: 'post' },
    // 提交配额申请
    editquota: { url: '/postoffice/license/quota/', method: 'put' },
    // 编辑配额申请
    editquotaAppl: { url: '/vehicle/apiservice', method: 'post', apidata: 1 },
    // 删除配额申请
    deletequotaAppl: { url: '/vehicle/apiservice', method: 'post', apidata: 1 },

    // 配额使用管理
    // 获取使用情况列表
    getAssociationQuota: { url: '/postoffice/ExpressQuota', method: 'get' },
    // 使用记录列表
    getUsedQuota: { url: '/postoffice/UsedQuota', method: 'get' },
    // 快递公司查询自己的配额使用量
    getquotause: { url: '/postoffice/express/quota/info', method: 'get' },


    // 车辆监控
    // 监控车辆列表
    trafficPoliceListGet: { url: '/traffic/police/list', method: 'get' },
    // 车辆监控
    trafficMapVehiclePost: { url: '/traffic/map/vehicle', method: 'post' },
    //获取GPS点列表
    trafficGpsPost: { url: '/traffic/gps', method: 'post' },
    //根据子系统机构id查询快递公司信息
    trafficSubCompanyPost: { url: '/traffic/sub/company', method: 'post' },
    //车辆监控详情
    trafficPoliceDetailGet: { url: 'traffic/police/detail', method: 'get' },
    //获取当前用户地区
    authAreaInfoGet: { url: '/auth/AreaInfo', method: 'get' },
    //获取当前城市所有的电子围栏
    vehicleAreaRail: { url: '/vehicle/area/rail', method: 'get' },
    //获取所有站点
    serverApiservice: { url: 'dispatch-server/apiservice', method: 'post', apidata: 1 },
    //获取所有围栏
    bizApiservice: { url: 'biz/apiservice', method: 'post', apidata: 1 },
    // 10306-根据城市ID查询路口和信号灯(大屏后期使用)
    trafficLightListByCityGet: { url: '/biz/apiservice', method: 'post', apidata: 1 },


    //年检任务
    /**查询列表*快递协会 */
    postofficeInspectionGet: { url: '/postoffice/inspection', method: 'get' },
    /**查询列表*快递公司 */
    dispatchYearcheckGet: { url: '/dispatch/yearcheck', method: 'get' },
    /***查看历史详情 */
    // postofficeInspectionVehicleGet: { url: '/postoffice/inspection/vehicle', method: 'get' },
    // 新增年检项
    postofficeInspectionPrintPost: { url: '/postoffice/inspection/print', method: 'post' },
    /***查看历史详情 */
    postofficeInspectionHistoryGet: { url: '/postoffice/inspection/history', method: 'get' },
    //年检审核
    postofficeInspectionAuditPut: { url: '/postoffice/inspection/audit', method: 'put' },
    //年检激活
    postofficeInspectionActivePut: { url: 'postoffice/inspection/active', method: 'put' },
    //快递公司获取全部站点
    dispatchYearcheckSelectSiteGet: { url: '/dispatch/yearcheck/select/site', method: 'get' },





    // 年检项管理
    // 获取列表
    getYearCheckManageList: { url: '/postoffice/inspection/item', method: 'get' },
    // 新增年检项
    addYearCheckManageList: { url: '/postoffice/inspection/item', method: 'post' },
    // 编辑年检项
    editYearCheckManageList: { url: '/postoffice/inspection/item/', method: 'put' },
    // 修改年检状态
    changeYearCheckManageStatus: { url: '/postoffice/inspection/item/status/', method: 'put' },
    // 修改年检状态
    delYearCheckManage: { url: '/postoffice/inspection/item/', method: 'delete' },


    // 年检情况统计
    getYearStatistics: { url: '/postoffice/inspection/statistics/company', method: 'get' },
    // 年检情况报表导出
    expressYearStatisticsExport: { url: '/postoffice/inspection/statistics/company/export', method: 'get' },
    // 站点年检情况统计
    getYearSiteStatistics: { url: '/postoffice/inspection/statistics/site', method: 'get' },
    // 快递公司下拉站点列表
    getYearSiteList: { url: '/postoffice/inspection/select/site', method: 'get' },
    // 快递协会下拉快递公司【查看年检情况统计页面用】
    getYearExpressList: { url: '/postoffice/inspection/select/express', method: 'get' },
    // 导出站点年检情况
    siteYearStatisticsExport: { url: '/postoffice/inspection/statistics/site/export', method: 'get' },

    // 年检车辆查询【邮管/协会查看已打印过行驶证车辆】
    getLicenseIssuedList: { url: '/vehicle/apiservice', method: 'post', apidata: 1 },
    // 车辆使用统计
    getVehicleUsage: { url: '/vehicle/apiservice', method: 'post', apidata: 1 },
    // 快递公司获取昨日车辆使用率
    getExpressVehicleUsage: { url: '/vehicle/apiservice', method: 'post', apidata: 1 },
    // 车辆使用统计月使用趋势
    getMonthVehicleUsage: { url: '/vehicle/MonthVehicleUsage', method: 'post' },
    // 车辆使用统计年使用趋势
    getYearVehicleUsage: { url: '/vehicle/YearVehicleUsage', method: 'post' },


    // 快递公司获取昨日车辆使用率
    vehicleLifeVideo: { url: '/vehicle/lifeVideo', method: 'post', apidata: 1 },

    // 行政区域管理
    // 获取列表
    getAdministrativeList: { url: '/area', method: 'get' },
    // 新增行政区域
    addAdministrativeList: { url: '/area', method: 'post' },
    // 编辑行政区域
    editAdministrativeList: { url: '/area/', method: 'put' },
    // 删除行政区域
    deleteAdministrativeList: { url: '/area/', method: 'delete' },

    // 车辆智能化
    // 获取列表
    getDeviceModelList: { url: '/intelligent/DeviceModel', method: 'get' },
    // 新增设备型号
    addDeviceModel: { url: '/intelligent/DeviceModel', method: 'post' },
    // 编辑设备型号
    editDeviceModel: { url: '/intelligent/DeviceModel/', method: 'put' },
    // 删除设备型号
    deleteDeviceModel: { url: '/intelligent/DeviceModel/', method: 'delete' },
    // 设备型号下拉选择供应商
    deviceModelSupplier: { url: '/intelligent/select/supplier', method: 'get' },
    // 查询采集频率
    frequencyInfoDetail: { url: 'intelligent/frequency/info', method: 'post' },
    // 新增采集频率
    frequencyAdd: { url: 'intelligent/frequency/add', method: 'post' },
    // 更新采集频率
    frequencyEdit: { url: 'intelligent/frequency/update', method: 'post' },
    // 邮管车辆数据
    // 数据列表
    getPostOfficeVehicle: { url: '/vehicle/apiservice', method: 'post', apidata: 1 },
    // 获取所有车型名称
    getPostVehicleModel: { url: 'vehicle/apiservice', method: 'post', apidata: 1 },
    // 编辑邮管车辆数据
    editPostOfficeVehicle: { url: '/vehicle/apiservice', method: 'post', apidata: 1 },
    // 删除邮管车辆数据
    deletePostOfficeVehicle: { url: '/vehicle/apiservice', method: 'post', apidata: 1 },
    // 邮管车辆数据详情
    postOfficeDetail: { url: '/vehicle/apiservice', method: 'post', apidata: 1 },
    // 邮管车辆数据详情列表
    postOfficeDetailList: { url: '/vehicle/apiservice', method: 'post', apidata: 1 },
    // 下拉选择站点
    getPostOfficeSite: { url: '/dispatch-server/apiservice', method: 'post', apidata: 1 },
    // 下拉选择职能设备号
    getPostOfficeDeviceModel: { url: '/intelligent/select/deviceModel', method: 'get' },

    // 后装预约页面
    // 获取预约列表
    vehicleDeviceInstall: { url: '/vehicle/deviceInstall', method: 'get' },
    // 获取所有城市列表
    vehicleCityList: { url: '/vehicle/cityList', method: 'get' },
    // 获取后装设备详情
    vehicleDeviceInstallDetail: { url: '/vehicle/deviceInstall/detail', method: 'get' },
    // 车辆导入
    vehicleDeviceInstallImport: { url: '/vehicle/deviceInstall/import', method: 'post' },
    // 获取快递公司列表
    vehicleCompanyList: { url: '/vehicle/companyList', method: 'get' },
    // 获取城市下的门店列表
    vehicleCityStoreList: { url: '/vehicle/storeList', method: 'get' },
    // 获取门店统计列表
    vehicleStoreStatistics: { url: '/vehicle/storeCount', method: 'get' },
    // 获取中移门店统计列表
    cmccStoreStatistics: { url: '/combine/apiservice', method: 'post', apidata: 1 },
    // 获取门店统计详情
    vehicleStoreDetail: { url: '/vehicle/storeCount/detail', method: 'get' },
    // 获取中移门店统计详情
    cmccVehicleStoreDetail: { url: '/combine/apiservice', method: 'post', apidata: 1 },
    // 导出门店统计
    exportStoreCount: { url: '/vehicle/storeCount/export', method: 'get' },
    // 导出安装日统计
    exportStoreCountDay: { url: '/vehicle/storeCount/exportDay', method: 'get' },
    // 新增预约
    addVehicleDeviceInstall: { url: '/vehicle/deviceInstall', method: 'post' },
    // 编辑预约任务
    editVehicleDeviceInstall: { url: 'vehicle/deviceInstall', method: 'put' },
    // 更新预约任务
    vehicleDeviceInstallUpdate: { url: 'vehicle/deviceInstall/update', method: 'put' },
    // 后装详情中删除车辆的安装记录
    delVehicleDeviceInstallDetail: { url: '/vehicle/deviceInstall/detail', method: 'delete' },
    // 安装日志
    installationLogList: { url: 'vehicle/apiservice', method: 'post', apidata: 1 },
    // 获取操作门店
    installationOptStore: { url: 'vehicle/apiservice', method: 'post', apidata: 1 },
    // 获取开通邮管业务的城市
    installationOptCity: { url: 'vehicle/apiservice', method: 'post', apidata: 1 },
    // 安装统计报表列表
    installationReportList: { url: 'vehicle/apiservice', method: 'post', apidata: 1 },
    // 导出安装统计报表
    exportInstallationReport: { url: 'vehicle/apiservice', method: 'post', apidata: 1 },

    //业务设置
    //获取业务设置
    postofficeSystemParamGet: { url: '/postoffice/system/param', method: 'get' },
    // 提交业务设置
    postofficeSystemParamPost: { url: '/postoffice/system/param', method: 'post' },


    //品牌管理 车辆型号
    //品牌参数不同（新增:10062、查询:10063、修改:10064、删除:10065）
    //车辆型号参数不同（新增:10066、删除:10071、修改：10068、查询:10067、关联快递协会：10070）
    productServerApiservicePost: { url: '/product-server/apiservice', method: 'post', apidata: 1 },

    // 原子系统apiMap
    // 区域部门
    // 站点管理列表
    siteList: { url: '/dispatch/site', method: 'get' },
    // 新增站点
    addsite: { url: '/dispatch/site', method: 'post' },
    // 修改站点
    editsite: { url: '/dispatch/site/', method: 'put' },
    // 删除站点
    deletesite: { url: '/dispatch/site/', method: 'delete' },
    // 编辑业务员
    editDispatchStaff: { url: '/dispatch/staff', method: 'post' },
    // 删除业务员
    delDispatchStaff: { url: '/dispatch/staff', method: 'delete' },
    // 区域列表
    regionList: { url: '/dispatch/region', method: 'get' },
    // 新增区域
    addregion: { url: '/dispatch/region', method: 'post' },
    // 修改区域信息
    editregion: { url: '/dispatch/region/', method: 'put' },
    // 删除区域
    deleteregion: { url: '/dispatch/region/', method: 'delete' },

    // 里程报表
    // 获取所有车辆里程报表
    getMileageList: { url: '/vehicle/apiservice', method: 'post', apidata: 1 },
    getRealUseDay: { url: '/newvehicle/apiservice', method: 'post', apidata: 1 },
    /**职能用户列表* */
    dispatchExpressUser: { url: '/dispatch/express/user', method: 'get' },
    // 图表信息
    childvehicleChart: { url: '/vehicle/apiservice', method: 'post', apidata: 1 },

    // 获取邮管骑手数据
    driversList: { url: '/dispatch-server/apiservice', method: 'post', apidata: 1 },
    // 编辑/禁用骑手信息
    driversEdit: { url: '/dispatch-server/apiservice', method: 'post', apidata: 1 },


    //车辆检测平台
    //（查询全省所有快递协会下的骑手：60033,60034）
    dispatchServerApiservicePost: { url: '/dispatch-server/apiservice', method: 'post', apidata: 1 },
    //(查询全省配额情况:15060,15062,15061  换电区域价格：列表22000  编辑22002,快递公司违章查询：15029)
    bizApiservicePost: { url: '/biz/apiservice', method: 'post', apidata: 1 },
    //(七日车辆使用统计:60038,60036,60039)
    // 获取gps列表  60306
    vehicleApiservice: { url: '/vehicle/apiservice', method: 'post', apidata: 1 },
    // 数字生活订单信息88801、商品信息88802
    logisticsScreenApiservice: { url: '/logistics-screen-server/apiservice', method: 'post', apidata: 1 },

    //运营商管理
    //品牌（列表：21000 新增：21001  编辑：2100  删除：21000  查看详情：21002  21007-获取当前运营商经营范围  20000-获取所有经营范围）
    //查询企业（10200）   获取所属企业（10202）
    //修改密码（10067）
    usercenterApiservicePost: { url: '/usercenter/apiservice', method: 'post', apidata: 1 },
    //电池板块
    //品牌（列表：10081 新增：10078  编辑：10079  删除：10080）
    productServerApiservicePost: { url: '/product-server/apiservice', method: 'post', apidata: 1 },

    //平台服务费
    rentServicefeeGet: { url: '/rent/Servicefee', method: 'get' },



    // 车辆管理
    // 快递公司车辆统计（快递协会）
    getExpressCarStatisticsList: { url: 'vehicle/apiservice', method: 'post', apidata: 1 },

    // 轨迹回放测试页面
    pathTest: { url: '/vehicle/apiservice', method: 'post', apidata: 1 },


    // 充电柜生产任务
    // 生产任务
    productionTaskList: { url: '/chargingpile-admin/apiservice', method: 'post', apidata: 1 },
    // 查询所有城市
    productionCityList: { url: '/biz/apiservice', method: 'post', apidata: 1 },
    // 根据城市查询快递公司
    productionExpressList: { url: '/usercenter/apiservice', method: 'post', apidata: 1 },
    // 根据快递公司查询站点
    productionSiteList: { url: '/dispatch-server/apiservice', method: 'post', apidata: 1 },

    // 充电桩监控大屏
    chargingMonitor: { url: '/chargingpile-admin/apiservice', method: 'post', apidata: 1 },
    // AI接口（
    // 10086-查询末端配送车辆，10088-查询安检中心列表，
    // 10091-人员组织架构列表，10085-查询机构基本信息，
    // 10087-查询报警类型列表，10089-查询监控中心，
    // 10090-查询整改单，
    // 11001-获取摄像头列表数据，
    // 11003 -首页各个管理机构筛选数据接口，
    // 10092 -查询车辆电子围栏和轨迹，
    // ）
    aiScreenApiservice: { url: '/ai-screen/apiservice', method: 'post', apidata: 1 },
    bizLifeOrderPayUserList: { url: '/biz/life/order/payUser/list', method: 'post', apidata: 1 },
    // biz服务
    bizApiservice: { url: '/biz/apiservice', method: 'post', apidata: 1 },
    // 无人车服务
    driverLesscarApiservice: { url: '/driverlesscar/apiservice', method: 'post', apidata: 1 },
    // 数字生活地图定位
    vehicleLocation: { url: '/vehicle/location', method: 'post', apidata: 1 },
    //首页实时订单
    vehicleOrderStatus: { url: '/vehicle/orderStatus', method: 'post', apidata: 1 },
    //首页排行
    vehicleProductInfo: { url: '/vehicle/productInfo', method: 'post', apidata: 1 },

    //农场详情
    //农场摄像头列表
    vehicleCarmeraListInfo: { url: '/vehicle/dataLife/farm/videoStream/list/', method: 'post', apidata: 1 },
    //农场信息
    vehicleFarmInfo: { url: '/vehicle/dataLife/farm/info/query/', method: 'post', apidata: 1 },
    //农场运营趋势
    vehicleFarmDataInfo: { url: '/vehicle/dataLife/farm/operationTrend/list/', method: 'post', apidata: 1 },
    //配送
    orderCitypcOrderlist: { url: '/order/order/city/pc/orderlist', method: 'post', apidata: 1 },
    //分配
    orderSameCityDeliveryAssignDriver: { url: '/order/sameCityDelivery/assignDriver', method: 'post', apidata: 1 },
    //取消订单

    orderCanclecityorder: { url: '/order/canclecityorder', method: 'post', apidata: 1 },
    logisticsScreenServerApiservice: { url: '/logistics-screen-server/apiservice', method: 'post', apidata: 1 },

    logisticsScreenApiservice: { url: '/logistics-screen-server/apiservice', method: 'post', apidata: 1 },



};
export default methodMap;



// WEBPACK FOOTER //
// ./src/libs/apiMap.js